import Cookies from 'js-cookie';
import {
  AIDT_ACCESS_ID,
  AIDT_ACCESS_TOKEN,
  AIDT_KEY_ID,
  AIDT_LOGIN_AUTH_PARTNER_ID,
  AIDT_SSO_RETURN_TOKEN,
  AIDT_SECURENONCE,
  LOGIN_AUTH_TOKEN_KEY,
  AIDT_USER_ID,
  AIDT_LECTURE_CODE,
  AIDT_API_DOMAIN,
} from '@shared/constants/token';

export const clearCookies = () => {
  Cookies.remove(AIDT_ACCESS_ID);
  Cookies.remove(AIDT_ACCESS_TOKEN);
  Cookies.remove(AIDT_KEY_ID);
  Cookies.remove(LOGIN_AUTH_TOKEN_KEY);
  Cookies.remove(AIDT_SECURENONCE);
  Cookies.remove(AIDT_LOGIN_AUTH_PARTNER_ID);
  Cookies.remove(AIDT_SSO_RETURN_TOKEN);
  Cookies.remove(AIDT_USER_ID);
  Cookies.remove(AIDT_API_DOMAIN);
  Cookies.remove(AIDT_LECTURE_CODE);
};
